import { Dispatch, AnyAction } from 'redux';
import { AppState } from '../redux';
import {
  STORE_CUSTOMEREMAIL_PROFILE,
  STORE_CUSTOMERPHONENUMBER_PROFILE,
  STORE_CUSTOMERADDRESSONE_PROFILE,
  STORE_CUSTOMERADDRESSTWO_PROFILE,
  STORE_CUSTOMERCOUNTRY_PROFILE,
  STORE_CUSTOMERSTATE_PROFILE,
  STORE_CUSTOMERPRODUCT_PROFILE,
  STORE_CUSTOMERSCANNER_PROFILE,
  STORE_CUSTOMERCONTACTNAME_PROFILE,
  STORE_CUSTOMERCONTACTNUMBER_PROFILE,
  STORE_CUSTOMERCOMMENT_PROFILE,
  STORE_USERPROFILEDATA,
  STORE_CUSTOMERNAME_PROFILE,
  STORE_CUSTOMEROCCLUSION,
  STORE_CUSTOMERDESIGNTYPE,
  STORE_CUSTOMERPONTICDESIGN,
  STORE_CUSTOMERCONTACT,
  STORE_CUSTOMERNOTE,
  STORE_CUSTOMERMODELTYPE,
  STORE_CUSTOMERDSOFT_PROFILE,
  STORE_CUSTOMERCUSTDEST_PROFILE,
  STORE_CUSTOMERCUSTTAT_PROFILE
} from '../reducers/userProfile';
import {
  STORE_SUCCESS_FILES_UPLOADED_MSG,
  STORE_SUCCESS_FILES_UPLOADED,
  STORE_ERROR_FILES_UPLOADED_MSG,
  STORE_ERROR_FILES_UPLOADED,
} from '../reducers/errors';
import axios, { AxiosResponse, AxiosError } from 'axios';
// import { push } from 'react-router-redux';

export const getUserProfileData = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
  const sessionid = getState().user.userDetails.s || '';
  await axios({
    method: 'post',
    url: `${getState().environment.API_URL}getProfileData?userId=${encodeURIComponent(getState().user.userDetails.userName)}`,
    headers: {
      sessionid: sessionid || ''
    },
  }).then(function (response: AxiosResponse) {

    const userProfiledata = response.data[0];
    dispatch({ type: STORE_USERPROFILEDATA, userProfiledata } as AnyAction);

    const custname = getState().userProfileData.userProfiledata.custname;
    const custemail = getState().userProfileData.userProfiledata.emailid;
    const custnumber = getState().userProfileData.userProfiledata.phoneno;
    const custaddressone = getState().userProfileData.userProfiledata.address1;
    const custaddresstwo = getState().userProfileData.userProfiledata.address2;
    const custcountry = getState().userProfileData.userProfiledata.country;
    const custstate = getState().userProfileData.userProfiledata.state;
    const custproduct = getState().userProfileData.userProfiledata.products;
    const custscanner = getState().userProfileData.userProfiledata.scanners;
    const custcontactName = getState().userProfileData.userProfiledata.contactname;
    const custcontactNumber = getState().userProfileData.userProfiledata.contactno;
    const custcomment = getState().userProfileData.userProfiledata.comments;
    const custdsoft = getState().userProfileData.userProfiledata.dsoft;
    const custdest = getState().userProfileData.userProfiledata.destination;
    const custtat = getState().userProfileData.userProfiledata.tat;
    const occlusion = getState().userProfileData.userProfiledata.occlusion;
    const designtype = getState().userProfileData.userProfiledata.designtype;
    const ponticdesign = getState().userProfileData.userProfiledata.ponticdesign;
    const contact = getState().userProfileData.userProfiledata.contact;
    const modeltype = getState().userProfileData.userProfiledata.modeltype;
    const notes = getState().userProfileData.userProfiledata.notes;

    dispatch({ type: STORE_CUSTOMERNAME_PROFILE, custname } as AnyAction);
    dispatch({ type: STORE_CUSTOMEREMAIL_PROFILE, custemail } as AnyAction);
    dispatch({ type: STORE_CUSTOMERPHONENUMBER_PROFILE, custnumber } as AnyAction);
    dispatch({ type: STORE_CUSTOMERADDRESSONE_PROFILE, custaddressone } as AnyAction);
    dispatch({ type: STORE_CUSTOMERADDRESSTWO_PROFILE, custaddresstwo } as AnyAction);
    dispatch({ type: STORE_CUSTOMERCOUNTRY_PROFILE, custcountry } as AnyAction);
    dispatch({ type: STORE_CUSTOMERSTATE_PROFILE, custstate } as AnyAction);
    dispatch({ type: STORE_CUSTOMERPRODUCT_PROFILE, custproduct } as AnyAction);
    dispatch({ type: STORE_CUSTOMERSCANNER_PROFILE, custscanner } as AnyAction);
    dispatch({ type: STORE_CUSTOMERCONTACTNAME_PROFILE, custcontactName } as AnyAction);
    dispatch({ type: STORE_CUSTOMERCONTACTNUMBER_PROFILE, custcontactNumber } as AnyAction);
    dispatch({ type: STORE_CUSTOMERCOMMENT_PROFILE, custcomment } as AnyAction);
    dispatch({ type: STORE_CUSTOMERDSOFT_PROFILE, custdsoft } as AnyAction);
    dispatch({ type: STORE_CUSTOMERCUSTDEST_PROFILE, custdest } as AnyAction);
    dispatch({ type: STORE_CUSTOMERCUSTTAT_PROFILE, custtat } as AnyAction);
    dispatch({ type: STORE_CUSTOMEROCCLUSION, occlusion } as AnyAction);
    dispatch({ type: STORE_CUSTOMERDESIGNTYPE, designtype } as AnyAction);
    dispatch({ type: STORE_CUSTOMERPONTICDESIGN, ponticdesign } as AnyAction);
    dispatch({ type: STORE_CUSTOMERCONTACT, contact } as AnyAction);
    dispatch({ type: STORE_CUSTOMERMODELTYPE, modeltype } as AnyAction);
    dispatch({ type: STORE_CUSTOMERNOTE, notes } as AnyAction);

  }).catch(function (error: AxiosError) {

    const errorFileUploadedOpen = true;
    const errorfilemsg = error.message;
    dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);

  });

  // await axios({
  //   method: 'post',
  //   url: `${getState().environment.API_URL}getDesignPreferenceValues`,
  //   headers: {
  //     sessionid: sessionid || ''
  //   },
  // }).then(function (response: AxiosResponse) {

  //   const designPref = response.data;
  //   dispatch({ type: STORE_DESIGNPREF_DATA, designPref } as AnyAction);

  //   const occulsionArr = designPref.filter((occulsion: DesignPref) => {
  //     return occulsion.fieldname === 'occlusion';
  //   });
  //   dispatch({ type: STORE_DESIGNPREF_OCCULSION, occulsionArr } as AnyAction);

  //   const designtypeArr = designPref.filter((designtype: DesignPref) => {
  //     return designtype.fieldname === 'designtype';
  //   });
  //   dispatch({ type: STORE_DESIGNPREF_DESIGNTYPE, designtypeArr } as AnyAction);

  //   const contactArr = designPref.filter((contact: DesignPref) => {
  //     return contact.fieldname === 'contact';
  //   });
  //   dispatch({ type: STORE_DESIGNPREF_CONTACT, contactArr } as AnyAction);

  //   const ponticdesignArr = designPref.filter((ponticdesign: DesignPref) => {
  //     return ponticdesign.fieldname === 'ponticdesign';
  //   });
  //   dispatch({ type: STORE_DESIGNPREF_PONTICDESIGN, ponticdesignArr } as AnyAction);

  //   const modeltypeArr = designPref.filter((modeltype: DesignPref) => {
  //     return modeltype.fieldname === 'modeltype';
  //   });
  //   dispatch({ type: STORE_DESIGNPREF_MODELTYPE, modeltypeArr } as AnyAction);

  // }).catch(function (error: AxiosError) {

  //   const errorFileUploadedOpen = true;
  //   const errorfilemsg = error.message;
  //   dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
  //   dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);

  // });

};

export const updateEmail = (custemail: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMEREMAIL_PROFILE, custemail } as AnyAction);
    return true;
  };
};

export const updateNumber = (custnumber: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    // const customerphonenumber: number = Math.round(parseInt(pno, 10));
    dispatch({ type: STORE_CUSTOMERPHONENUMBER_PROFILE, custnumber } as AnyAction);
    return true;
  };
};

export const updateAddressOne = (custaddressone: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERADDRESSONE_PROFILE, custaddressone } as AnyAction);
    return true;
  };
};

export const updateAddressTwo = (custaddresstwo: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERADDRESSTWO_PROFILE, custaddresstwo } as AnyAction);
    return true;
  };
};

export const updateCountry = (custcountry: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERCOUNTRY_PROFILE, custcountry } as AnyAction);
    return true;
  };
};

export const updateState = (custstate: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERSTATE_PROFILE, custstate } as AnyAction);
    return true;
  };
};

export const updateProduct = (custproduct: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERPRODUCT_PROFILE, custproduct } as AnyAction);
    return true;
  };
};

export const updateScanner = (custscanner: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERSCANNER_PROFILE, custscanner } as AnyAction);
    return true;
  };
};

export const updateContactname = (custcontactName: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERCONTACTNAME_PROFILE, custcontactName } as AnyAction);
    return true;
  };
};

export const updateContactnumber = (custcontactNumber: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERCONTACTNUMBER_PROFILE, custcontactNumber } as AnyAction);
    return true;
  };
};

export const updateComment = (custcomment: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERCOMMENT_PROFILE, custcomment } as AnyAction);
    return true;
  };
};
export const updateDsoftware = (custdsoft: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERDSOFT_PROFILE, custdsoft } as AnyAction);
    return true;
  };
};
export const updateDestination = (custdest: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERCUSTDEST_PROFILE, custdest } as AnyAction);
    return true;
  };
};
export const updateTat = (custtat: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERCUSTTAT_PROFILE, custtat } as AnyAction);
    return true;
  };
};
export const updateOcclusion = (occlusion: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMEROCCLUSION, occlusion } as AnyAction);
    return true;
  };
};
export const updateDesignType = (designtype: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERDESIGNTYPE, designtype } as AnyAction);
    return true;
  };
};
export const updatePonticDesign = (ponticdesign: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERPONTICDESIGN, ponticdesign } as AnyAction);
    return true;
  };
};
export const updateContact = (contact: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERCONTACT, contact } as AnyAction);
    return true;
  };
};
export const updateModelType = (modeltype: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERMODELTYPE, modeltype } as AnyAction);
    return true;
  };
};
export const updateNotes = (notes: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERNOTE, notes } as AnyAction);
    return true;
  };
};

export const resetProfile = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
  const custname = getState().userProfileData.userProfiledata.custname;
  const custemail = getState().userProfileData.userProfiledata.emailid;
  const custnumber = getState().userProfileData.userProfiledata.phoneno;
  const custaddressone = getState().userProfileData.userProfiledata.address1;
  const custaddresstwo = getState().userProfileData.userProfiledata.address2;
  const custcountry = getState().userProfileData.userProfiledata.country;
  const custstate = getState().userProfileData.userProfiledata.state;
  const custproduct = getState().userProfileData.userProfiledata.products;
  const custscanner = getState().userProfileData.userProfiledata.scanners;
  const custcontactName = getState().userProfileData.userProfiledata.contactname;
  const custcontactNumber = getState().userProfileData.userProfiledata.contactno;
  const custcomment = getState().userProfileData.userProfiledata.comments;
  const custdsoft = getState().userProfileData.userProfiledata.dsoft;
  const custdest = getState().userProfileData.userProfiledata.destination;
  const custtat = getState().userProfileData.userProfiledata.tat;
  const occlusion = getState().userProfileData.userProfiledata.occlusion;
  const designtype = getState().userProfileData.userProfiledata.designtype;
  const ponticdesign = getState().userProfileData.userProfiledata.ponticdesign;
  const contact = getState().userProfileData.userProfiledata.contact;
  const modeltype = getState().userProfileData.userProfiledata.modeltype;
  const notes = getState().userProfileData.userProfiledata.notes;

  dispatch({ type: STORE_CUSTOMERNAME_PROFILE, custname } as AnyAction);
  dispatch({ type: STORE_CUSTOMEREMAIL_PROFILE, custemail } as AnyAction);
  dispatch({ type: STORE_CUSTOMERPHONENUMBER_PROFILE, custnumber } as AnyAction);
  dispatch({ type: STORE_CUSTOMERADDRESSONE_PROFILE, custaddressone } as AnyAction);
  dispatch({ type: STORE_CUSTOMERADDRESSTWO_PROFILE, custaddresstwo } as AnyAction);
  dispatch({ type: STORE_CUSTOMERCOUNTRY_PROFILE, custcountry } as AnyAction);
  dispatch({ type: STORE_CUSTOMERSTATE_PROFILE, custstate } as AnyAction);
  dispatch({ type: STORE_CUSTOMERPRODUCT_PROFILE, custproduct } as AnyAction);
  dispatch({ type: STORE_CUSTOMERSCANNER_PROFILE, custscanner } as AnyAction);
  dispatch({ type: STORE_CUSTOMERCONTACTNAME_PROFILE, custcontactName } as AnyAction);
  dispatch({ type: STORE_CUSTOMERCONTACTNUMBER_PROFILE, custcontactNumber } as AnyAction);
  dispatch({ type: STORE_CUSTOMERCOMMENT_PROFILE, custcomment } as AnyAction);
  dispatch({ type: STORE_CUSTOMERDSOFT_PROFILE, custdsoft } as AnyAction);
  dispatch({ type: STORE_CUSTOMERCUSTDEST_PROFILE, custdest } as AnyAction);
  dispatch({ type: STORE_CUSTOMERCUSTTAT_PROFILE, custtat } as AnyAction);
  dispatch({ type: STORE_CUSTOMEROCCLUSION, occlusion } as AnyAction);
  dispatch({ type: STORE_CUSTOMERDESIGNTYPE, designtype } as AnyAction);
  dispatch({ type: STORE_CUSTOMERPONTICDESIGN, ponticdesign } as AnyAction);
  dispatch({ type: STORE_CUSTOMERCONTACT, contact } as AnyAction);
  dispatch({ type: STORE_CUSTOMERMODELTYPE, modeltype } as AnyAction);
  dispatch({ type: STORE_CUSTOMERNOTE, notes } as AnyAction);
};

export const resetDesignPreferences = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
  // dispatch(push('/app/designpreference'));
  const occlusion = getState().userProfileData.userProfiledata.occlusion;
  const designtype = getState().userProfileData.userProfiledata.designtype;
  const ponticdesign = getState().userProfileData.userProfiledata.ponticdesign;
  const contact = getState().userProfileData.userProfiledata.contact;
  const modeltype = getState().userProfileData.userProfiledata.modeltype;
  const notes = getState().userProfileData.userProfiledata.notes;

  dispatch({ type: STORE_CUSTOMEROCCLUSION, occlusion } as AnyAction);
  dispatch({ type: STORE_CUSTOMERDESIGNTYPE, designtype } as AnyAction);
  dispatch({ type: STORE_CUSTOMERPONTICDESIGN, ponticdesign } as AnyAction);
  dispatch({ type: STORE_CUSTOMERCONTACT, contact } as AnyAction);
  dispatch({ type: STORE_CUSTOMERMODELTYPE, modeltype } as AnyAction);
  dispatch({ type: STORE_CUSTOMERNOTE, notes } as AnyAction);
};

export const doUserProfileUpdate = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

  const params = {
    custcode: '',
    emailid: '',
    phoneno: '',
    address1: '',
    address2: '',
    country: '',
    state: '',
    products: '',
    scanners: '',
    contactname: '',
    contactno: '',
    comments: '',
    dsoft: '',
    destination: '',
    tat: ''
  };
  const sessionid = getState().user.userDetails.s || '';

  params.custcode = getState().userProfileData.userProfiledata.custcode || '';
  params.emailid = getState().userProfileData.custemail || '';
  params.phoneno = getState().userProfileData.custnumber || '';
  params.address1 = getState().userProfileData.custaddressone || '';
  params.address2 = getState().userProfileData.custaddresstwo || '';
  params.country = getState().userProfileData.custcountry || '';
  params.state = getState().userProfileData.custstate || '';
  params.products = getState().userProfileData.custproduct || '';
  params.scanners = getState().userProfileData.custscanner || '';
  params.contactname = getState().userProfileData.custcontactName || '';
  params.contactno = getState().userProfileData.custcontactNumber || '';
  params.comments = getState().userProfileData.custcomment || '';
  params.dsoft = getState().userProfileData.custdsoft || '';
  params.destination = getState().userProfileData.custdest || '';
  params.tat = getState().userProfileData.custtat || '';

  if (params.emailid === '') {
    const errorFileUploadedOpen = true;
    const errorfilemsg = 'Email should not be blank.';
    dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
    return;
  } else {
    const errorFileUploadedOpen = false;
    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
  }

  if (params.phoneno === '') {
    const errorFileUploadedOpen = true;
    const errorfilemsg = 'Phone number should not be blank.';
    dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
    return;
  } else {
    const errorFileUploadedOpen = false;
    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
  }

  if (params.address1 === '') {
    const errorFileUploadedOpen = true;
    const errorfilemsg = 'Address One should not be blank.';
    dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
    return;
  } else {
    const errorFileUploadedOpen = false;
    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
  }

  if (params.address2 === '') {
    const errorFileUploadedOpen = true;
    const errorfilemsg = 'Address Two should not be blank.';
    dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
    return;
  } else {
    const errorFileUploadedOpen = false;
    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
  }

  if (params.contactname === '') {
    const errorFileUploadedOpen = true;
    const errorfilemsg = 'Contact Name should not be blank.';
    dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
    return;
  } else {
    const errorFileUploadedOpen = false;
    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
  }

  if (params.contactno === '') {
    const errorFileUploadedOpen = true;
    const errorfilemsg = 'Contact Person Number should not be blank.';
    dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
    return;
  } else {
    const errorFileUploadedOpen = false;
    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
  }

  await axios({
    method: 'post',
    url: `${getState().environment.API_URL}updateProfile`,
    data: params,
    headers: {
      sessionid: sessionid || ''
    },
  }).then(async function (response: AxiosResponse) {

    getUserProfileData(dispatch, getState);

    const successFileUploadOpen = true;
    const successfilemsg = 'Profile has been updated successfully';
    dispatch({ type: STORE_SUCCESS_FILES_UPLOADED_MSG, successfilemsg } as AnyAction);
    dispatch({ type: STORE_SUCCESS_FILES_UPLOADED, successFileUploadOpen } as AnyAction);

  }).catch(error => {

    resetProfile(dispatch, getState);

    const errorFileUploadedOpen = true;
    const errorfilemsg = error.resposne.data.msg;
    dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);

  });
};

export const doDesignPreferencesUpdate = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

  const params = {
    custname: '',
    customer: '',
    occlusion: '',
    contact: '',
    designtype: '',
    ponticdesign: '',
    modeltype: '',
    notes: ''
  };
  const sessionid = getState().user.userDetails.s || '';
  params.custname = getState().userProfileData.custname || '';
  params.customer = getState().userProfileData.userProfiledata.custcode || '';
  params.occlusion = getState().userProfileData.occlusion || '';
  params.contact = getState().userProfileData.contact || '';
  params.designtype = getState().userProfileData.designtype || '';
  params.ponticdesign = getState().userProfileData.ponticdesign || '';
  params.modeltype = getState().userProfileData.modeltype || '';
  params.notes = getState().userProfileData.notes || '';

  if (params.occlusion === '') {
    const errorFileUploadedOpen = true;
    const errorfilemsg = 'occlusion should not be blank.';
    dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
    return;
  } else {
    const errorFileUploadedOpen = false;
    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
  }

  if (params.designtype === '') {
    const errorFileUploadedOpen = true;
    const errorfilemsg = 'designtype should not be blank.';
    dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
    return;
  } else {
    const errorFileUploadedOpen = false;
    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
  }

  if (params.ponticdesign === '') {
    const errorFileUploadedOpen = true;
    const errorfilemsg = 'ponticdesign should not be blank.';
    dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
    return;
  } else {
    const errorFileUploadedOpen = false;
    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
  }

  if (params.contact === '') {
    const errorFileUploadedOpen = true;
    const errorfilemsg = 'contact should not be blank.';
    dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
    return;
  } else {
    const errorFileUploadedOpen = false;
    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
  }

  if (params.modeltype === '') {
    const errorFileUploadedOpen = true;
    const errorfilemsg = 'modeltype should not be blank.';
    dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
    return;
  } else {
    const errorFileUploadedOpen = false;
    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
  }

  if (params.notes === '') {
    const errorFileUploadedOpen = true;
    const errorfilemsg = 'notes should not be blank.';
    dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
    return;
  } else {
    const errorFileUploadedOpen = false;
    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
  }

  await axios({
    method: 'post',
    url: `${getState().environment.API_URL}updateDesignPreferenceValues`,
    data: params,
    headers: {
      sessionid: sessionid || ''
    },
  }).then(async function (response: AxiosResponse) {

    const successFileUploadOpen = true;
    const successfilemsg = 'Design Preference has been updated successfully';
    dispatch({ type: STORE_SUCCESS_FILES_UPLOADED_MSG, successfilemsg } as AnyAction);
    dispatch({ type: STORE_SUCCESS_FILES_UPLOADED, successFileUploadOpen } as AnyAction);
    // dispatch(push('/app/designpreference'));

  }).catch(error => {

    const errorFileUploadedOpen = true;
    const errorfilemsg = error.response.data.msg;
    dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
  });
};



// WEBPACK FOOTER //
// ./src/actions/userProfileAction.ts